export default "__VITE_ASSET__R50bp3y5__"